import React, { useState, useEffect } from 'react';
import { DiffText } from './DiffView';
import { getEditorBoundary } from './utils/viewportUtils';
import './Changelog.css';

export default function Changelog({
  changes = [],
  position,
  onClear,
  onToggleCollapse,
  isCollapsed = false
}) {
  const [editorBoundary, setEditorBoundary] = useState(null);
  const [editorHeight, setEditorHeight] = useState(null);

  // Get editor boundary and height on mount
  useEffect(() => {
    const updateEditorDimensions = () => {
      const boundary = getEditorBoundary();
      setEditorBoundary(boundary);

      const editorElement = document.querySelector('.ProseMirror');
      if (editorElement) {
        const editorHeight = editorElement.offsetHeight;
        setEditorHeight(editorHeight);
      }
    };

    updateEditorDimensions();

    // Update on scroll to handle dynamic height changes
    const handleScroll = () => {
      updateEditorDimensions();
    };

    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  if (!position) return null;

  const formatTimestamp = (timestamp) => {
    return new Date(timestamp).toLocaleTimeString([], {
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit'
    });
  };

  // Set height to match editor height
  const containerHeight = editorHeight ? `${editorHeight}px` : '400px';


  return (
    <div
      className="changelog-container"
      style={{
        left: `${position.x}px`,
        top: `${position.y}px`,
        height: containerHeight,
      }}
    >
      <div className="changelog-header">
        <div className="changelog-header-content">
          <div>
            <span className="changelog-title">📝 Change Log</span>
            <span className="changelog-subtitle">
              {changes.length} {changes.length === 1 ? 'change' : 'changes'}
            </span>
          </div>
        </div>
        <div className="changelog-actions">
          <button
            onClick={onToggleCollapse}
            className="changelog-close-button"
            title="Close changelog"
          >
            ✕
          </button>
        </div>
      </div>

      <div className="changelog-content">
        {changes.length === 0 ? (
          <div className="changelog-empty">
            <span className="empty-icon">📋</span>
            <span className="empty-text">No changes yet</span>
            <span className="empty-description">
              Accepted changes will appear here
            </span>
          </div>
        ) : (
          <div className="changelog-entries">
            {changes.map((change, index) => (
              <div key={index} className="changelog-entry">
                <div className="changelog-entry-header">
                  <span className="entry-timestamp">
                    {formatTimestamp(change.timestamp)}
                  </span>
                  <span className="entry-badge">✓</span>
                </div>

                <div className="changelog-diff">
                  <div className="diff-section">
                    <span className="diff-label">Changes:</span>
                    <div className="diff-text">
                      <DiffText
                        originalText={change.originalText}
                        newText={change.newText}
                      />
                    </div>
                  </div>
                </div>

                <div className="changelog-entry-footer">
                  <span className="entry-context">
                    {change.context || 'No additional context'}
                  </span>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
